module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av56-6f841c4dd18d76fd66664107913e0a96.jpg";